import apiSportsFederations from '@/api/sports-federations'

const state = {
    isLoading: false,
    sportsFederation: null,
    validationErrors: null,
    isSubmitting: false
}

export const mutationTypes = {
    updateSportFederationsStart: '[update sportsFederations] updateSportFederationsStart',
    updateSportFederationsSuccess: '[update sportsFederations] updateSportFederationsSuccess',
    updateSportFederationsFailure: '[update sportsFederations] updateSportFederationsFailure',

    getSportFederationsStart: '[update sportsFederations] getSportFederationsStart',
    getSportFederationsSuccess: '[update sportsFederations] getSportFederationsSuccess',
    getSportFederationsFailure: '[update sportsFederations] getSportFederationsFailure'
}

export const actionType = {
    updateSportFederations: '[update sportsFederations] updateSportFederations',
    getSportFederations: '[update sportsFederations] getSportFederations'
}

const mutations = {
    [mutationTypes.updateSportFederationsStart](state) {
        state.isSubmitting = true
        state.validationErrors = null
    },

    [mutationTypes.updateSportFederationsSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.updateSportFederationsFailure](state, payload) {
        state.isSubmitting = false
        state.validationErrors = payload
    },

    [mutationTypes.getSportFederationsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },

    [mutationTypes.getSportFederationsSuccess](state, payload) {
        state.isLoading = false
        state.sportsFederation = payload
    },

    [mutationTypes.getSportFederationsFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    }
}

const actions = {
    [actionType.getSportFederations](context, {id}) {
        context.commit(mutationTypes.getSportFederationsStart)
        return new Promise(resolve => {
            apiSportsFederations
                .getSportFederation(id)
                .then(response => {
                    context.commit(mutationTypes.getSportFederationsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.getSportFederationsFailure,
                        result.response.data.errors
                    )
                })
        })
    },

    [actionType.updateSportFederations](context, sport) {
        context.commit(mutationTypes.updateSportFederationsStart)
        return new Promise(resolve => {
            apiSportsFederations
                .updateSportFederations(sport)
                .then(response => {
                    context.commit(mutationTypes.updateSportFederationsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.updateSportFederationsFailure,
                        result.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
